import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { GradientFill } from 'components/VisualStudioPlayground/FillColor/GradientFill'
import { ColorSwatch } from '../ColorSwatch/ColorSwatch'
import { GradientColor } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { NewGradientButtonProps } from './Types'
import Plus from './Plus'
import Styles from './ColorsPanel.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const WHITE_GRADIENT_COLOR: GradientColor = {
  type: 'linearGradient',
  angle: 90,
  stops: [
    { color: '#FFFFFF', position: 0, opacity: 1 },
    { color: '#FFFFFF', position: 1, opacity: 1 },
  ],
}

const DEFAULT_GRADIENT_COLOR: GradientColor = {
  type: 'linearGradient',
  angle: 90,
  stops: [
    { color: '#F8D832', position: 0, opacity: 1 },
    { color: '#8C7605', position: 1, opacity: 1 },
  ],
}

export const NewGradientButton = ({ onChange, isSelected, onOpenChange }: NewGradientButtonProps) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <DropdownTrigger onOpenChange={onOpenChange} popoverClassName={Styles.popover}>
      <ColorSwatch isSelected={isSelected} color={WHITE_GRADIENT_COLOR} size={isMobile ? 42 : 30}>
        <span className={Styles.newColorSwatchIcon}>
          <Plus color="var(--dark-80)" />
        </span>
      </ColorSwatch>

      {() => <GradientFill value={DEFAULT_GRADIENT_COLOR} onChange={onChange} />}
    </DropdownTrigger>
  )
}
